import { Cache } from "memory-cache";
import { CorporationProjectListEntity } from ".";

// Cache
const cache = new Cache();
export async function getCachedCorporationProjectListEntity(
  id: string,
  corporation_id: number
): Promise<CorporationProjectListEntity | null> {
  let entity: any = await cache.get(id.toString() + "-" + corporation_id.toString());
  if (entity) {
    return entity;
  }
  return null;
}
export function setCachedCorporationProjectListEntity(project: CorporationProjectListEntity, corporation_id: number) {
  cache.put(project.props.id.toString() + "-" + corporation_id.toString(), project, 15 * 60 * 1000 /* 15 min */);
}
